// src/components/ThirdPartyContact/Components/ThirdPartyContactInfoStep.js
import React from "react";
import {
  FormControl,
  FormLabel,
  TextField,
  FormHelperText,
  Select,
  MenuItem,
} from "@mui/material";

const ThirdPartyContactInfoStep = ({
  formData,
  formErrors,
  handleChange,
  fields,
  isEditMode = false,
}) => {
  return (
    <>
      {fields.map((field) => (
        <FormControl
          key={field.key}
          fullWidth
          error={Boolean(formErrors[field.key])}
          sx={{ mb: 2 }}
        >
          <FormLabel>{field.name}</FormLabel>
          {field.type === "select" ? (
            <Select
              name={field.key}
              value={formData[field.key] || ""}
              onChange={handleChange}
              displayEmpty
            >
              <MenuItem value="">
                <em>Select an option</em>
              </MenuItem>
              {field.options?.map((option) => (
                <MenuItem key={option} value={option}>
                  {option}
                </MenuItem>
              ))}
            </Select>
          ) : (
            <TextField
              name={field.key}
              type={field.type}
              placeholder={field.placeholder || ""}
              value={formData[field.key] || ""}
              onChange={handleChange}
              fullWidth
              variant="outlined"
              disabled={isEditMode && (field.key === "fullName" || field.key === "email")}
            />
          )}
          {formErrors[field.key] && (
            <FormHelperText>{formErrors[field.key]}</FormHelperText>
          )}
        </FormControl>
      ))}
    </>
  );
};

export default ThirdPartyContactInfoStep;
